/* MODAL WINDOW JS */

define(['jquery', 'Mustache'], function ($, Mustache) {
   "use strict";

   var self = {},
      m_jModal,
      fModalShownCallback = null,
      fModalHiddenCallback = null;

   self.onDocumentReady = function () {
      // Legacy
   };

   // "Propery". Ha.
   self.contactProperyModal = function(sId, sType) {
      $.get('/eco/contact/propertymodalform/', {pid: sId, sourcetype: sType}, function(data) {
         self.modal('Contact', {
            body: data[0].html,
            size: 'lg'
         });
      });
   };

   // IDX Property
   self.contactIDXProperyModal = function(obid, source, feed, officekey, sType) {
      $.get('/eco/contact/idxpropertymodalform/', {obid: obid, source: source, feed: feed, officekey: officekey, sourcetype: sType}, function(data) {
         self.modal('Contact', {
            body: data[0].html,
            size: 'lg'
         });
      });
   };

   function initializeModals() {
      if (m_jModal) return;

      m_jModal = $('.notification-modal');
      m_jModal.on('hidden.bs.modal', function (e) {
         if (fModalHiddenCallback) {
            fModalHiddenCallback(e);
            fModalHiddenCallback = null;
         }
      }).on('shown.bs.modal', function (e) {
         if (fModalShownCallback) {
            fModalShownCallback(e);
            fModalShownCallback = null;
         }
      });
   }

   /**
    * @param title
    * @param options - If a string is passed in, this will be the body, otherwise an option array:
    *      body: string html of body
    *      bodyUrl: URL to request body content
    *      bodyUrlData: object parameters to pass to bodyUrl
    *      iframeUrl:
    *      iframeHeight:
    *      templateId: id of element containing Mustache template for body
    *      template: string of Mustache template for body
    *      templateUrl: URL to the Mustache template for body
    *      modelUrl: URL to reqest body model JSON
    *      modelUrlData: object parameters to pass to modelUrl
    *      model: model object for Mustache template - will be extended and override model downloaded through AJAX
    *      shown: callback function on modal shown
    *      hidden: callback function on modal hidden
    *      type: default styling of glyphicon for 'info', 'warn', 'error', or 'question'
    *      icon: icon class e.g. "glyphicon glyphicon-cloud" see http://getbootstrap.com/components/
    *      iconColor: #rrggbb for icon color, defaults to header text color
    *      size: lg or sm - default lg
    * @returns {*|jQuery|HTMLElement}
    *
    * modalWindow.modal('Hello World', 'Simple Body');
    *
    * modalWindow.modal('Hello World', {
     *   template: 'My favorite fruit is {{fruit}}',
     *   model: { fruit: 'apple' },
     *   shown: function() { alert('shown'); },
     *   hidden: function() { alert('hidden'); },
     *   icon: 'glyphicon glyphicon-star-empty',
     *   iconColor: 'blue',
     *   size: 'sm'
     * });
    *
    * modalWindow.modal('Example with XHR Body', {
     *   bodyUrl: '/test/test.php',
     *   bodyUrlData: { q: 'Testing'},
     *   type: 'error',
     * });
    *
    * modalWindow.modal('AJAX Model and XHR Template', {
     *   templateUrl: '/test/test.htm',
     *   modelUrl: '/test/test.json',
     *   type: 'info'
     * });
    */
   self.modal = function (title, o) {
      initializeModals();

      var sTitleIcon = "";

      var jTitle = m_jModal.find('.modal-title');
      var jBody = m_jModal.find('.modal-body'),
         options = {
            size: 'md'
         };
      if (typeof o === "string") {
         options.body = o;
      } else {
         $.extend(options, o);
      }

      m_jModal.find(".modal-dialog").removeClass('modal-sm modal-lg modal-md').addClass('modal-' + options.size);

      if (title === null) {
         jTitle.hide();
      } else {
         jTitle.show();
         if (options.type) {
            switch (options.type) {
               case 'info':
                  options.icon = "brand-info glyphicon glyphicon-info-sign";
                  break;
               case 'warn':
                  options.icon = "brand-warning glyphicon glyphicon-warning-sign";
                  break;
               case 'error':
                  options.icon = "brand-danger glyphicon glyphicon-exclamation-sign";
                  break;
               case 'question':
                  options.icon = "brand-primary glyphicon glyphicon-question-sign";
            }
         }

         if (options.icon) {
            sTitleIcon = "<span class='" + options.icon + "'";
            if (options.iconColor) {
               sTitleIcon += " style='color: " + options.iconColor + "'";
            }
            sTitleIcon += "></span> ";
         }

         jTitle.html(sTitleIcon + title);
      }

      if (options.body) {
         jBody.html(options.body);
      } else if (options.iframeUrl) {
         jBody.html('<iframe border="0" style="border: none" width="99.6%" height="' + options.iframeHeight + '" src="' + options.iframeUrl + '"></iframe>');
      } else if (options.bodyUrl) {
         jBody.load(options.bodyUrl, options.bodyUrlData);
      } else if (options.templateId || options.template || options.templateUrl) {
         var template = options.template,
            render = function () {
               if (options.modelUrl) {
                  $.get(options.modelUrl, options.modelUrlData, function (data) {
                     jBody.html(Mustache.render(template, $.extend(data, options.model)));
                  }, 'json');
               } else {
                  jBody.html(Mustache.render(template, options.model));
               }
            };
         if (options.templateId) {
            template = $("#" + options.templateId).html();
         }
         if (options.templateUrl) {
            $.get(options.templateUrl, null, function (data) {
               template = data;
               render();
            });
         } else {
            render();
         }
      }

      fModalShownCallback = options.shown;
      fModalHiddenCallback = options.hidden;

      m_jModal.modal('show');

      return m_jModal;
   };

   self.closeModal = function () {
      if (!m_jModal) return;
      m_jModal.modal('hide');
   };

   return self;

});
